
import React from 'react';

const Datenschutz = () => {
    return (
        <section id="datenschutz" className="py-20 bg-background">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
                <h1 className="text-4xl font-bold mb-8 text-foreground">Datenschutzerklärung</h1>

                <div className="space-y-6 text-muted-foreground">
                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-foreground">1. Verantwortlicher</h2>
                        <p>
                            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
                        </p>
                        <p className="mt-2">
                            Christopher Hahnen<br />
                            Am Hirtenäckerle 2B<br />
                            77694 Kehl
                        </p>
                        <p className="mt-2">
                            E-Mail: <a href="mailto:info@xearox.de" className="text-primary hover:underline">info@xearox.de</a>
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-foreground">2. Hosting</h2>
                        <p>
                            Diese Webseite wird auf einem privaten, selbst betriebenen Server gehostet. Es findet keine Übertragung von Daten an externe Hosting-Dienstleister statt.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-foreground">3. Datenerfassung auf dieser Website</h2>
                        <h3 className="text-xl font-medium mb-2 text-foreground">Cookies</h3>
                        <p>
                            Diese Website verwendet keine Cookies. Es werden keine Daten auf Ihrem Endgerät gespeichert, um Sie wiederzuerkennen oder Ihr Verhalten zu verfolgen.
                        </p>

                        <h3 className="text-xl font-medium mb-2 mt-4 text-foreground">Server-Log-Dateien</h3>
                        <p>
                            Es werden keine Server-Log-Dateien (Logfiles) erstellt oder gespeichert. Wir protokollieren keine IP-Adressen oder andere Zugriffsdaten der Besucher.
                        </p>

                        <h3 className="text-xl font-medium mb-2 mt-4 text-foreground">Bilder und Medien</h3>
                        <p>
                            Alle auf der Website verwendeten Bilder sind eigene Aufnahmen und liegen lokal auf dem Server. Es werden keine Ressourcen von Drittanbietern (CDNs, externe Bildhoster) geladen, wodurch keine IP-Adressen an Dritte weitergegeben werden.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-foreground">4. Ihre Rechte</h2>
                        <p>
                            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten (sofern vorhanden), deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung oder Löschung dieser Daten. Da wir keine personenbezogenen Daten der Besucher speichern, gibt es technisch gesehen in diesem Kontext in der Regel nichts zu beauskunften oder zu löschen. Für Fragen hierzu können Sie sich jederzeit unter der oben angegebenen Adresse an uns wenden.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-foreground">5. Kontakt</h2>
                        <p>
                            Bei Fragen zum Datenschutz wenden Sie sich bitte per E-Mail an <a href="mailto:info@xearox.de" className="text-primary hover:underline">info@xearox.de</a>.
                        </p>
                    </section>
                </div>
            </div>
        </section>
    );
};

export default Datenschutz;
